import { Box } from "@mui/system";
import { CustomViewFields, CustomViewUpdateFab } from "../CustomViewModal";
import { useCustomModel } from "components/context/CustomProvider";

const ModelViewPage = ({ modelName, data }) => {
  const model = useCustomModel(modelName);

  return (
    <Box sx={{ maxWidth: "600px", mx: "auto" }}>
      <CustomViewFields data={data} fields={model.fields} />
      {model.updateModal && (
        <CustomViewUpdateFab data={data} itemUpdateModal={model.updateModal} />
      )}
    </Box>
  );
};

export default ModelViewPage;
